import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Paper,
  DialogActions,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiButton from "components/SuiButton";

import TabAcreencias from "./actualizar/tabAcreencias";
import TabBienes from "./actualizar/tabBienes";
import TabProcesosJudiciales from "./actualizar/tabProcesosJudiciales";

import useUserRoles from "hooks/useUserRoles";

import PDFApi from "api/pdfApi";
import BucketApi from "api/bucketApi";
import ProcesosApi from "api/procesosApi";

const ActualizarAcreenciasTabs = ({ open, onClose, procesoIdentificador, onSuccess }) => {
  const { user, roles } = useUserRoles();
  const [error, setError] = useState(undefined);
  const [proceso, setProceso] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const FILE_NAME = "pdf_actualizacion_acreencias.pdf";
  const ANEXO_TYPE = "PDF_ACTUALIZACION_ACREENCIAS";

  const fetchInitialData = async () => {
    try {
      const [procesoResp] = await Promise.all([
        ProcesosApi.fetchProcesoByIdentificador(procesoIdentificador),
      ]);
      setProceso(procesoResp.data);
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
      setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
    }
  };

  useEffect(() => {
    if (procesoIdentificador) {
      fetchInitialData();
    }
  }, [user, procesoIdentificador]);

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (window.confirm("¿Está seguro(a) de actualizar las acreencias del proceso?")) {
      try {
        const datos = {
          operacion: "ACTUALIZAR_ACREENCIAS",
          id_proceso: proceso.id,
        };
        const response = await ProcesosApi.operarProceso(datos);
        if (response.status === 201 && response.data) {
          const anexoResponse = await ProcesosApi.obtenerAnexoProcesoByTipo(proceso.id, {
            tipo_anexo: ANEXO_TYPE,
          });
          const anexo = anexoResponse.data;
          if (anexo != undefined && !anexoResponse.data.error) {
            await ProcesosApi.eliminarAnexoProceso(proceso.id, anexo.id);
          }
          // Generar PDF ACTUALIZACION ACREECNCIAS
          const pdfResponse = await PDFApi.generateDocument("actualizacionAcreencias", proceso.id);
          const pdfBlob = new Blob([pdfResponse.data], { type: "application/pdf" });
          const formData = new FormData();
          formData.append("file", pdfBlob, FILE_NAME);
          formData.append("file_type", "proceso");
          formData.append("proceso_id", proceso.identificador);
          formData.append("registrar_anexo", "true");
          formData.append("tipo_anexo", ANEXO_TYPE);
          formData.append("nombre_anexo", "Actualización Acreencias");
          await BucketApi.uploadFile(formData);
          alert("La Actualización de Acreencias fue realizada con éxito.");
          onSuccess();
        }
      } catch (error) {
        console.error(`Error al Actualizar Acreencias del Proceso:`, error);
      }
    }
  };

  const hCClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="large" fullWidth>
      <DialogTitle>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={6}>
            <h3>ACTUALIZACIÓN DE ACREENCIAS, BIENES y PROCESOS JURÍDICOS</h3>
            <strong>PROCESO: {proceso ? proceso.identificador : "No tiene Proceso"}</strong>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={12}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
          </Grid>
        </Grid>
        <Paper sx={{ width: "100%", padding: 1 }}>
          <Tabs value={tabIndex} onChange={handleTabChange} aria-label="tabs">
            <Tab label="Acreencias" />
            <Tab label="Bienes" />
            <Tab label="Procesos Judiciales" />
          </Tabs>
          {tabIndex === 0 && <TabAcreencias proceso={proceso} />}
          {tabIndex === 1 && <TabBienes proceso={proceso} />}
          {tabIndex === 2 && <TabProcesosJudiciales proceso={proceso} />}
        </Paper>
      </DialogContent>
      <DialogActions>
        <SuiButton onClick={hCClose} buttonColor="light">
          Cancelar
        </SuiButton>
        {(roles.isAdmin || roles.isCoordinador || roles.isOperador || roles.isDirector) && (
          <SuiButton variant="gradient" buttonColor="dark" onClick={handleSubmit}>
            {proceso ? "Generar PDF Actualición Acreencias, Bienes y Procesos Judiciales" : "..."}
          </SuiButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

ActualizarAcreenciasTabs.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  procesoIdentificador: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ActualizarAcreenciasTabs;
